import type { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import type { QueryClient } from '@tanstack/react-query';
import { signOut } from 'aws-amplify/auth';
import { clearPermissionsSession } from '@/lib/permissions-session';
import { queryClient as appQueryClient } from '@/lib/query-client';
import { store } from '@/redux/store';
import { clearUser } from '@/redux/userSlice';

type SignOutSessionDeps = {
  dispatch?: Dispatch<UnknownAction>;
  queryClient?: QueryClient;
};

export const signOutSession = async (deps: SignOutSessionDeps = {}): Promise<void> => {
  const dispatch = deps.dispatch ?? store.dispatch;
  const client = deps.queryClient ?? appQueryClient;
  clearPermissionsSession(dispatch, client);
  dispatch(clearUser());
  client.clear();
  await signOut();
};
